import { EntryWithID, LimitPagination } from '@/components/cms/types/entry';
import { transformBlogArticlesIntoRelatedArticlesProps } from '@/components/organisms/articles-feed/service';
import {
  ARTICLES_PER_PAGE,
  State,
} from '@/components/organisms/articles-feed/state';
import RelatedArticles from '@/components/organisms/relatedArticles';

type FeedProps = {
  initialArticle?: {
    data: EntryWithID[];
    pagination: LimitPagination;
  };
};

export function generateInitialState({
  articles,
  topic,
}: {
  articles?: {
    data: EntryWithID[];
    pagination: LimitPagination;
  };
  topic: string | null;
}): State {
  return {
    loading: false,
    offset: articles?.pagination ? articles?.pagination.start : 0,
    articles: articles?.data
      ? transformBlogArticlesIntoRelatedArticlesProps(articles?.data)
      : [],
    pagination: articles?.pagination ?? {
      limit: ARTICLES_PER_PAGE,
      start: 0,
      total: 0,
    },
    topic: topic ?? undefined,
  };
}

export function NewestArticle({ initialArticle }: FeedProps) {
  const state = generateInitialState({ articles: initialArticle, topic: null });

  return (
    <>
      <RelatedArticles
        items={state.articles}
        classNames={{ wrapper: 'md:grid md:grid-cols-1' }}
      />
    </>
  );
}
